import React from 'react';
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import UsersList from "../components/UsersList";
import UserForm from '../components/UserForm';
import { useParams } from 'react-router-dom';

const UserFormPage = ({mode}) => {
 const { id } = useParams();

 
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout >

        {/* Breadcrumb */}
        <Breadcrumb title={mode+" User"} />

        {/* DashBoardLayerSix */}
        <UserForm mode = {mode} id = {id} />



      </MasterLayout>
    </>
  );
}
export default UserFormPage;